import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Edges from '../../components/shared/Edges';
import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import Api from '../../api';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';

const CancelAppointment = (props) => {
    const _api = new Api();
    let history = useHistory();
    let location = useLocation();

    const [data, setData] = useState({
        isCancelled: false
    });

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('token');

        const cancelAppointment = async () => {
            const { status } = await _api.update(`/api/timeslot/cancelbooking?token=${token}`);
            if (status === 204)
                setData({
                    isCancelled: true
                });
            else toast.error('Error cancelling appointment. Please contact support.');
        };

        cancelAppointment();
    }, []);

    return (
        <Container>
            <Edges size='md'>
                {data.isCancelled && (
                    <div>
                        <ConfirmationMessage>
                            <Headline children={'Your appointment has been cancelled.'} />
                            <Content>
                                <CenteredDiv>
                                    <CloseButton onClick={() => history.push('/')}>Close</CloseButton>
                                </CenteredDiv>
                            </Content>
                        </ConfirmationMessage>
                    </div>
                )}
            </Edges>
        </Container>
    );
};

const Container = styled.div`
    padding: 40px 0;
`;

const ConfirmationMessage = styled.div`
    padding: 20px;
`;

const Headline = styled(Typography)`
    && {
        text-align: center;
        font-weight: 800;
        text-transform: capitalize;
        margin-bottom: 30px;
        color: #1f3d67;
        font-size: 25px;
        line-height: 22px;

        @media (min-width: 768px) {
            margin-bottom: 40px;
        }

        @media (max-width: 768px) {
            font-size: 18px;
        }
    }
`;

const Content = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 30px;
`;

const CloseButton = styled(Button)`
    && {
        width: 100px;
        background-color: #4e4e4e;
        color: #fff;
        padding: 10px 30px;
    }
`;

const CenteredDiv = styled.div`
    display: flex;
    width: 100%;
    margin: 20px 0;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    @media (min-width: 640px) {
        flex-direction: row;
    }
`;

export default CancelAppointment;
